<template>
  <div class="text-left position-relative">
    <div class="d-flex align-items-center gap-2 justify-content-between mb-1">
      <label class="fs-14 font-mont fw-500 color-darkblack"
        >{{ label }}<span v-show="isMandatory" class="asterik">*</span></label
      >
      <b-button
        class="acs-addBtn-modal px-2"
        v-show="showAI"
        @click="handleClick"
        :disabled="disableAI || explicitDisableAI"
      >
        <div
          class="d-flex align-items-center justify-content-center gap-1 w-100 h-100"
        >
          <div>Write with Hire3x</div>
          <!-- <img src="../../assets/course-structure/aibtn.svg" alt="" /> -->
        </div>
      </b-button>
    </div>

    <b-skeleton v-if="showLoader || aiLoader" height="100px"></b-skeleton>
    <template v-else>
      <quill-editor
        class="custom-quill-editor p-0"
        v-model.trim="editorOption.inputValue"
        :class="{ error: error, quilldisabled: disabled }"
        :options="editorOption"
        :disabled="disabled"
        @input="handleInput"
        :placeholder="placeholder"
      >
      </quill-editor>
      <!-- <template v-if="modelKey === '$model'">
        <span
          v-show="!vmodel.required && vmodel.$dirty && quillDirty"
          class="required-font tu-l0"
          >Required</span
        >
      </template> -->
    </template>
  </div>
</template>

<script>
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
export default {
  name: "CustomQuillEditor",
  components: {
    quillEditor,
  },
  props: {
    showLoader: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      required: true,
    },
    vmodel: {
      type: String,
      required: true,
    },
    isMandatory: {
      type: Boolean,
      default: true,
    },
    error: {
      type: Boolean,
      default: false,
    },
    quillDirty: {
      type: Boolean,
      default: true,
    },
    showAI: {
      type: Boolean,
      default: false,
    },
    disableAI: {
      type: Boolean,
      default: true,
    },
    aiLoader: {
      type: Boolean,
      default: false,
    },
    explicitDisableAI: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "Enter",
    },
  },
  data() {
    return {
      editorOption: {
        modules: {
          toolbar: [
            ["bold", "italic", "underline"],
            [
              {
                list: "ordered",
              },
              {
                list: "bullet",
              },
            ],
          ],
        },
        preserveWhitespace: true,
        placeholder: "Enter",
        inputValue: "",
      },
    };
  },
  created(){
    if(this.vmodel){
      this.editorOption.inputValue=this.vmodel
    }
  },
  watch: {
    vmodel(val) {
      this.editorOption.inputValue = val;
    },
  },
  methods: {
    handleClick() {
      this.$emit("clicked");
    },
    handleInput() {
      this.$emit("update-value");
      this.$emit("select-value", this.editorOption.inputValue);
    },
  },
};
</script>

<style>
.ql-editor {
  padding: 10px 14px;
}
.validationError {
  border: 1px solid red !important;
}
.quilldisabled {
  cursor: not-allowed;
}
.custom-quill-editor {
  border: 1px solid #d0d5dd;
  border-radius: 0.5rem;
}

.custom-quill-editor .ql-editor {
  background-color: var(--color-white);
  height: 6.5rem !important;
  white-space: normal !important;
  border-radius: 7px;
  font-family: "Lato", sans-serif;
  font-weight: 500;
  font-size: 16px;
  color: #565656;
}
.custom-quill-editor .quill-editor {
  border: 1px solid #d0d5dd;
  border-radius: 0.75rem;
  box-shadow: unset;
}
.custom-quill-editor .ql-container.ql-snow {
  border-radius: 0px 0px 0.375rem 0.375rem;
  border: unset;
}
.custom-quill-editor .ql-toolbar.ql-snow {
  background: var(--blue-container-background);
  border: unset;
  border-radius: 8px 8px 0px 0px;
  display: flex;
}
.ql-editor.ql-blank::before {
  font-style: normal;
  color: var(--input-placeholder);
  font-family: "Montserrat", sans-serif;
  font-weight: var(--weight-400);
  font-size: var(--size-14);
}
.acs-addBtn-modal {
  height: 20px;
  background: #20639b;
  font-family: "Lato", sans-serif;
  font-size: 11px;
  font-style: italic;
  font-weight: 500;
  color: #ffffff;
  border-radius: 16px;
  padding: 2px 5px;
}
.acs-addBtn-modal:hover {
  background: #20639b;
}
.acs-addBtn-modal:focus {
  background: #20639b !important;
  box-shadow: unset;
}
.acs-addBtn-modal:active {
  background: #20639b !important;
  box-shadow: unset;
}
.quilldisabled .ql-editor {
  background-color: #e4e4e5 !important;
  border-radius: 0;
}
.quilldisabled .ql-toolbar.ql-snow {
  opacity: 0.5;
  pointer-events: none;
}
</style>
